// What AI Calling (Super Agent) offers — shown in the "Coming Soon" panel
// (sidebar popup + the /ai-calling route gate). Kept in one place so both match.
// Mirrors the real campaign types (appointment_setter, policy_review,
// pre_qualification) + warm transfer, area-code matching, and follow-up texts.
/** Marketing tab — agent-funded, brand-consistent campaigns that land leads straight in the CRM. */
export const MARKETING_FEATURES = [
  "Campaigns featuring you, managed by the Licensedproducer team",
  "Choose your coverage focus, licensed states, and campaign budget",
  "Review and approve your photo, ad copy, and landing page before launch",
  "Campaign inquiries delivered to your InsuraCentral leads",
  "Track confirmed funding, reported spend, leads, and cost per lead",
];

export const AI_CALLING_FEATURES = [
  "Books appointments with your leads automatically",
  "Runs policy review & renewal reminder campaigns",
  "Pre-qualifies leads before they ever reach you",
  "Warm-transfers hot prospects to you live, mid-call",
  "Smart local area-code matching for higher pickup",
  "Auto follow-up texts + a live call analytics dashboard",
];

// What InsuraMentor offers — AI voice mentoring for sales practice.
// Mirrors the real scenario types (objection/discovery/closing drills),
// AI personas, multi-dimensional scoring, and AI mentoring feedback.
export const INSURA_TRAINING_FEATURES = [
  "Live voice mentoring with AI prospects — talk, don't type",
  "Drills for objections, discovery & closing",
  "AI personas built from real life-insurance calls",
  "Scored on objection handling, discovery, closing & rapport",
  "Personalized AI mentoring tips after every session",
  "Track your mastery & progress over time",
];
